import styled from "styled-components";
import { StyledGlobalMainContainer } from "../globalStyle";

export const StyledContainer = styled(StyledGlobalMainContainer)`
  display: grid;
  padding-top: 76px;
  padding-bottom: 102px;
  margin-top: 162px;
  @media (max-width: 768px) {
    padding: 40px 22px;
    margin-top: 100px;
  }
`;

export const StyledLogoContainer = styled.div`
  img {
    height: 44px;
  }
`;

export const StyledLogoContainerLeft = styled.div``;
export const StyledInnerContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  grid-column-gap: 57px;
`;

export const StyledGroupContainer = styled.div`
  display: grid;
  grid-template-columns: 2.3fr auto 1fr;
  grid-column-gap: 15px;
  @media (max-width: 960px) {
    grid-template-columns: 1fr auto 1fr;
  }
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    justify-self: start;
    grid-row-gap: 20px;
    grid-column-gap: 15px;
    width: 100%;
  }
`;

export const StyledLeftContainer = styled.div`
  justify-self: start;
  align-items: end;
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 47px;
  @media (max-width: 960px) {
    grid-auto-flow: row;
  }
`;

export const StyledRightContainer = styled.div`
  justify-self: end;
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  justify-items: end;
  grid-row-gap: 17px;
  @media (max-width: 960px) {
    grid-auto-rows: initial;
  }
  @media (max-width: 576px) {
    justify-self: start;
    justify-items: start;
  }
`;

export const StyledHr = styled.div`
  border: none;
  border-left: 0.8px solid #bfc4ca;
  height: 100%;
  @media (max-width: 576px) {
    border-top: 0.8px solid #bfc4ca;
  }
`;

export const StyledMainImageContainer = styled.div`
  height: 148px;
  position: relative;
  width: 400px;
  img {
    position: absolute;
    width: 100%;
    height: 100%;
  }
`;

export const StyledBarkleyLogoContainer = styled(StyledMainImageContainer)`
  width: 412px;
  @media (max-width: 1440px) {
    width: 350px;
  }
  @media (max-width: 1200px) {
    width: 300px;
  }
`;
export const StyledFiveHundredLogoContainer = styled(StyledMainImageContainer)`
  width: 240px;
  @media (max-width: 1440px) {
    width: 320px;
  }
  @media (max-width: 1200px) {
    width: 200px;
  }
`;
